import Subtopics from './Subtopics';

export default Subtopics;
